import { SavingThrowsTable, classForSavingThrows } from '../constants/savingthrows.js';
import flatten from '../components/Charsheet0/helpers/flatten.js';
import unflatten from '../components/Charsheet0/helpers/unflatten.js';
import getData from '../components/Charsheet0/helpers/get_data.js';
import getSavingThrows from './getSavingThrows.js'
import { calculateStrengthBonus } from './calculateStrengthBonus.js';
import { calculateDexBonus } from './calculateDexBonus.js';
import { calculateIntBonus } from './calculateIntBonus.js';
import { calculateWisBonus } from './calculateWisBonus.js';
import { calculateChaBonus } from './calculateChaBonus.js';
import { calculateConBonus } from './calculateConBonus.js';
import { RACE_ADJUSTMENTS, CON_ADJUSTMENTS } from '../constants/abilityAdjustments.js';
import { CLASS_HIT_DICE } from '../constants/classDefinitions.js';
import { rollDice, rollDie } from './rollDice.js';


export function toggleEdit({
  editing,
  setEditing,
  tempCharData,
  setTempCharData,
  setData,
  data
}, force=false) {

  
  const statFields = ['myStr', 'myInt', 'myWis', 'myDex', 'myCon', 'myCha', 'myClass', 'myLevel', 'myRace'];

  let dataIsUpdated = false

  console.log('force: ', force, 'editing: ', editing, data )

  // ---------- ENTER EDIT MODE ----------

  if (!editing && !force) {
    console.log('props.data:', data);
    console.log('Entering edit mode');
    
    const currentData = getData();
    
    console.log('initial CharData: ', currentData);

    setTempCharData(currentData);
    // Hide elements with class "editable-link"
    document.querySelectorAll(".editable-link").forEach((element) => {
      element.style.display = "none";
    });

    // Turn the statFields green
    statFields.forEach(field => {
      const inputElement = document.getElementById(field);
      if (inputElement) {
        inputElement.style.color = "rgb(10,88,0)";
      }
      
    });

    // Show elements with class "editable-input"
    setValuesFromButtonsToInputs();

    document.querySelectorAll(".editable-input").forEach((element) => {
      element.style.display = "block"; // Use "block" or "inline" based on your CSS requirements
    });

    setEditing(true);



  } else {     // ----- EXIT EDIT MODE ----
 
    let newCharData = ( force ? unflatten(data) : getData() )
    console.log(force)
    console.log('getData: ', getData())
    console.log('data: ', data )
    console.log('unflattened: ', unflatten(data) )
    console.log('Post-edit data: ', newCharData);
    console.log('Old data', tempCharData)

    console.log(tempCharData.chars)
    console.log('newCharData chars: ', newCharData.chars)
    console.log(JSON.parse(JSON.stringify(newCharData.chars)));
    
    // ----- CHECK FOR RACE CHANGE FIRST -----
    if (JSON.stringify(newCharData.chars) !== JSON.stringify(tempCharData.chars)) {
        const changedFields = Object.keys(newCharData.chars).filter(key => {
            return newCharData.chars[key] !== tempCharData.chars[key];
          });

    

      // if Race changed
      if (changedFields.includes('myRace')) {
        console.log('Race has changed')
                
        const raceKeys = Object.keys(RACE_ADJUSTMENTS);
        if (raceKeys.includes(tempCharData.chars.myRace) && raceKeys.includes(newCharData.chars.myRace)) {
          const oldRaceAdj = RACE_ADJUSTMENTS[tempCharData.chars.myRace]
          const newRaceAdj = RACE_ADJUSTMENTS[newCharData.chars.myRace]
          console.log(oldRaceAdj, ' ', newRaceAdj)
          // undo the changes to newCharData.stats from oldRaceAdj
          // then include changes to newCharData.stats from newRaceAdj
          console.log('before race adj: ',newCharData.stats)
          let oldvalue
          for (const stat in oldRaceAdj) {
            oldvalue = parseInt(newCharData.stats[`my${stat}`])
            newCharData.stats[`my${stat}`] = (oldvalue - oldRaceAdj[stat]).toString();
          }
          for (const stat in newRaceAdj) {
            oldvalue = parseInt(newCharData.stats[`my${stat}`])
            if (newCharData.stats[`my${stat}`] !== undefined) {
              newCharData.stats[`my${stat}`] = (oldvalue + newRaceAdj[stat]).toString();
            }
          }
          console.log('after race adj: ',newCharData.stats)
          dataIsUpdated = true;
        }
      }
    }  


    // ----- CHECK STATS FOR CHANGES -----
    if (JSON.stringify(newCharData.stats) !== JSON.stringify(tempCharData.stats)) {
      console.log('character stat data has changed');
      const changedFields = Object.keys(newCharData.stats).filter(key => {
        return newCharData.stats[key] !== tempCharData.stats[key];
      });
      console.log('Changed fields:', changedFields);

      // ----- React to CON changes -----
      if (changedFields.includes('myCon')){
          try {
          console.log(tempCharData.stats.myCon, newCharData.stats.myCon )

          console.log('oldConAdj: ', parseInt(tempCharData.stats.myCon.toString().replace(/[^0-9/]/g, '') ) )
          console.log('newConAdj: ', parseInt(newCharData.stats.myCon.toString().replace(/[^0-9/]/g, '') ) )

            const oldConAdj = CON_ADJUSTMENTS[ parseInt(tempCharData.stats.myCon.toString().replace(/[^0-9/]/g, '') ) ]
          
            let newConAdj = { ...CON_ADJUSTMENTS[parseInt(newCharData.stats.myCon.toString().replace(/[^0-9/]/g, '') ) ]};
          
            console.log('old: ', oldConAdj.hitPointAdj, 'new: ', newConAdj.hitPointAdj)
            // restrict the HP bonus to certain classes
            let isConBonusClass = false
            const conBonusClasses = ['Fighter', 'Paladin', 'Ranger', 'F/', '/F','Fig','Pal','Rgr','Ran']
            if (conBonusClasses.some((bonusClass) => newCharData.chars.myClass.includes(bonusClass)) ) {
                isConBonusClass = true;
            }
            if ( newCharData.chars.myClass === 'F') isConBonusClass = true;

            if (! isConBonusClass ) {
            console.log('adjusting down')
                newConAdj['hitPointAdj'] = Math.min(2, newConAdj['hitPointAdj'])
            }
            

            console.log('old: ', oldConAdj.hitPointAdj, 'new: ', newConAdj.hitPointAdj)
            // only react if the HP adjustment changes
            if (oldConAdj.hitPointAdj !== newConAdj.hitPointAdj ) {
                newCharData.stats.myConBon = newConAdj.hitPointAdj > 0 
                                              ? `+${newConAdj.hitPointAdj.toString()}` 
                                              : newConAdj.hitPointAdj.toString();
                // adjust hit points
                const hp_delta = (newConAdj.hitPointAdj - oldConAdj.hitPointAdj )
                const newHP = parseInt(newCharData.chars.myHPbase) + hp_delta * parseInt(tempCharData.chars.myLevel);
                console.log('old HP: ', newCharData.chars.myHPbase, 'new HP: ', newHP )
                newCharData.chars.myHPbase = newHP.toString();
                dataIsUpdated = true;
            }
          } catch(error) {
            console.log('failing gracefully')
            console.log(error)}
      }

      // ----- React to STR changes -----
      if (changedFields.includes('myStr')) {
        const newSTRBonus = calculateStrengthBonus(newCharData)
        const newSTRBonusString = newSTRBonus.str
        console.log('new STR Bonus ', newSTRBonusString)
        newCharData.stats['myStrBon'] = newSTRBonusString
        dataIsUpdated = true;
      }

      // ----- React to DEX changes -----
      if (changedFields.includes('myDex')) { 
        const newDEXBonus = calculateDexBonus(newCharData)
        newCharData.stats['myDexBon'] = newDEXBonus.str
        dataIsUpdated = true;
      }

      // ----- React to INT changes -----
      if (changedFields.includes('myInt')) { 
          const newINTBonus = calculateIntBonus(newCharData)
          newCharData.stats['myIntBon'] = newINTBonus.str
          dataIsUpdated = true;
      }

      // ----- React to WIS changes -----
      if (changedFields.includes('myWis')) { 
        const newWISBonus = calculateWisBonus(newCharData)
        newCharData.stats['myWisBon'] = newWISBonus.str
        dataIsUpdated = true;
      }

      // ----- React to CHA changes -----
      if (changedFields.includes('myCha')) { 
        const newCHABonus = calculateChaBonus(newCharData)
        newCharData.stats['myChaBon'] = newCHABonus.str
        dataIsUpdated = true;
      }

    } else {
      console.log('No changes to stats');
    }

    // ----- CHECK CHARS FOR CHANGES -----
    if (JSON.stringify(newCharData.chars) !== JSON.stringify(tempCharData.chars)) {
      console.log('character char(acteristics) data has changed');
      const changedFields = Object.keys(newCharData.chars).filter(key => {
        return newCharData.chars[key] !== tempCharData.chars[key];
      });
      console.log('Changed fields:', changedFields);

      // ----- React to CLASS or LEVEL changes -----
      if (changedFields.includes('myClass') || changedFields.includes('myLevel')) {
        const myClassNew = newCharData.chars['myClass'];
        const myLevelNew = newCharData.chars['myLevel'];

        let newSavingThrows = getSavingThrows(myClassNew, myLevelNew);

        console.log('new Saving Throws: ', newSavingThrows);

        // Update the saving throw values
        newCharData.saves['mySav1'] = newSavingThrows['poison'].toString();
        newCharData.saves['mySav2'] = newSavingThrows['poly'].toString();
        newCharData.saves['mySav3'] = newSavingThrows['wand'].toString();
        newCharData.saves['mySav5'] = newSavingThrows['breath'].toString();
        newCharData.saves['mySav4'] = newSavingThrows['magic'].toString();


        console.log('copy of newCharData before CON BONUS: ', JSON.parse(JSON.stringify(newCharData)) )
        const CON_BONUS = calculateConBonus(JSON.parse(JSON.stringify(newCharData)))

        if ( changedFields.includes('myClass') && myLevelNew === "1") {
          
          // re-roll hit points for L1 characters who change class
          try {
            const hitDie = CLASS_HIT_DICE[myClassNew];
            
            // get CON adjustment
            console.log('CON BONUS: ',CON_BONUS)
            let HP_adj = parseInt(CON_BONUS.dict.hitPointAdj, 10)
              
            // calculate hit points
            const [numDice, dieType] = hitDie.split('d').map(Number);
            let hp = 0;
            for (let i = 0; i < numDice; i++) {
              hp += rollDie(dieType);
            }
            alert(`Class changed for level 1 character.\n\nRe-rolling Hit Points ${CLASS_HIT_DICE[myClassNew]}\n\nRoll: ${hp}`)
            console.log("Con:", newCharData.stats['myCon'], "HP_adj: ", HP_adj, "HP_before:",  hp )
            hp += HP_adj * numDice;
            console.log('HP changed: ', hp)
            
            newCharData.chars.myHPbase = hp.toString()
            newCharData.stats.myConBon = CON_BONUS.str
            
            // add 
          } catch(error) { console.log(error)}

        }

        dataIsUpdated = true;
        
      }


    } else {
      console.log('No changes to chars');
    }

    // Save the new data
    if (dataIsUpdated) {
      let dataToFlatten = {};
      dataToFlatten['name'] = data.name;
      dataToFlatten['chardata'] = JSON.parse(JSON.stringify(newCharData));
      setData(flatten(dataToFlatten),'toggleEdit');
      setTempCharData(newCharData)
    }

    // Turn the statFields black
    statFields.forEach(field => {
      const inputElement = document.getElementById(field);
      if (inputElement) {
        inputElement.style.color = "royalblue";
      }
    });

    // Show elements with class "editable-link"
    document.querySelectorAll(".editable-link").forEach((element) => {
      element.style.display = "block"; // Use "block" or "inline" based on your CSS requirements
    });

    // Hide elements with class "editable-input"
    document.querySelectorAll(".editable-input").forEach((element) => {
      element.style.display = "none";
    });

    setEditing(false);
  }

  
}

    // ------ When going into edit mode, populate the editable fields with current data ------  
    function setValuesFromButtonsToInputs() {
        for (let i = 11; i <= 55; i++) {
          const button = document.getElementById(`mySp${i}-but`);
          const input = document.getElementById(`mySp${i}`);
          
          if (button && input) {
            input.value = button.textContent;
          }
        }
        for (let i = 1; i <= 6; i++) {
          let button = document.getElementById(`myMag${i}-but`);
          let input = document.getElementById(`myMag${i}`);          
          if (button && input) { input.value = ( button.innerHTML === "&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;" ? "" : button.textContent ); }

          button = document.getElementById(`myOth${i}-but`);
          input = document.getElementById(`myOth${i}`);          
          if (button && input) { input.value = ( button.innerHTML === "&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;" ? "" : button.textContent ); }

          button = document.getElementById(`myPot${i}-but`);
          input = document.getElementById(`myPot${i}`);          
          if (button && input) { input.value = ( button.innerHTML === "&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;" ? "" : button.textContent ); }

          button = document.getElementById(`myArm${i}-but`);
          input = document.getElementById(`myArm${i}`);          
          if (button && input) { input.value = ( button.innerHTML === "&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;" ? "" : button.textContent ); }

          button = document.getElementById(`myWeap${i}-but`);
          input = document.getElementById(`myWeap${i}`);          
          if (button && input) { input.value = ( button.innerHTML === "&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;" ? "" : button.textContent ); } 
          
        }
      }